import { usePackageBookingStore } from "@elixir/stores";
import { PACKAGE_PRICING_MODEL, PACKAGE_TYPE } from "@elixir/types";
import { PackageBreakdownUi } from "ui";

const PackageBreakdown = () => {
  const packagePopupType = usePackageBookingStore(
    (state) => state.packagePopupType
  );
  const packageDetails = usePackageBookingStore(
    (state) => state.packageDetails
  );
  const setPackageDetails = usePackageBookingStore(
    (state) => state.setPackageDetails
  );

  const sessionList = usePackageBookingStore((state) => state.sessionList);
  const setIncreaseSession = usePackageBookingStore(
    (state) => state.setIncreaseSession
  );
  const setDecreaseSession = usePackageBookingStore(
    (state) => state.setDecreaseSession
  );

  const handlePackageName = (name: string) => {
    if (packageDetails) {
      setPackageDetails({
        ...packageDetails,
        package_name: name,
      });
    }
  };

  const handleModifyAccess = (staffModifyAccess: boolean) => {
    if (packageDetails) {
      setPackageDetails({
        ...packageDetails,
        staff_modify_access: staffModifyAccess,
      });
    }
  };

  const handleFamilyMembers = (maxMembers: string) => {
    if (packageDetails) {
      setPackageDetails({
        ...packageDetails,
        max_members: parseInt(maxMembers),
      });
    }
  };

  const handlePackageExpiry = (packageExpiry: string) => {
    if (packageDetails) {
      setPackageDetails({
        ...packageDetails,
        package_expiry_from_start: parseInt(packageExpiry),
      });
    }
  };

  const handleCountClick = (type: "inc" | "dec") => {
    if (type == "inc") {
      setIncreaseSession();
    } else {
      setDecreaseSession();
    }
  };

  const handlePricingModel = (pricingModel: PACKAGE_PRICING_MODEL) => {
    if (packageDetails) {
      setPackageDetails({
        ...packageDetails,
        pricing_model: pricingModel,
      });
    }
  };

  const handlePackageDescription = (description: string) => {
    if (packageDetails) {
      setPackageDetails({
        ...packageDetails,
        description: description,
      });
    }
  };

  const handlePackagePrice = (price: string) => {
    if (packageDetails) {
      setPackageDetails({
        ...packageDetails,
        total_price: parseFloat(price),
      });
    }
  };

  const handlePackageType = (packageType: PACKAGE_TYPE) => {
    if (packageDetails) {
      setPackageDetails({
        ...packageDetails,
        type: packageType,
      });
    }
  };

  return (
    <PackageBreakdownUi
      packagePopupType={packagePopupType}
      packageType={packageDetails?.type}
      staffModifyAccess={!!packageDetails?.staff_modify_access}
      setStaffModifyAccess={handleModifyAccess}
      packageFamilyMembers={packageDetails?.max_members?.toString() || ""}
      setPackageFamilyMembers={handleFamilyMembers}
      packageExpiry={
        packageDetails?.package_expiry_from_start?.toString() || ""
      }
      setPackageExpiry={handlePackageExpiry}
      sessionCount={sessionList.length}
      handleCountClick={handleCountClick}
      pricingModel={packageDetails?.pricing_model}
      setPricingModel={handlePricingModel}
      packageName={packageDetails?.package_name || ""}
      setPackageName={handlePackageName}
      packageDescription={packageDetails?.description || ""}
      setPackageDescription={handlePackageDescription}
      packagePrice={
        !packageDetails?.total_price
          ? ""
          : isNaN(Number(packageDetails?.total_price))
            ? ""
            : packageDetails?.total_price?.toString()
      }
      setPackagePrice={handlePackagePrice}
      selectedPackageType={
        packageDetails?.type || PACKAGE_TYPE.SUBSCRIPTION_PLAN
      }
      setSelectedPackageType={handlePackageType}
    />
  );
};

export default PackageBreakdown;
